module.exports = __webpack_public_path__ + "img/98.f75e41a5.png";